var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.item.isSuccess
        ? [
            _c(
              "v-card-title",
              {
                class: {
                  "card-bg-2 font-weight-medium py-1": _vm.isRoot,
                  "pt-2 pb-1": !_vm.isRoot,
                },
              },
              [_vm._v("\n      The rollback removed:\n    ")]
            ),
            _vm._v(" "),
            _c(
              "v-card-text",
              { staticClass: "py-2" },
              _vm._l(_vm.serviceKeys, function (dataKey, i) {
                return _c(
                  "div",
                  { key: i },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "no-transition mr-1",
                        attrs: { color: dataKey.color },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              dataKey.icon
                                ? dataKey.icon
                                : _vm.getMediaTypeIcon(_vm.item.media_type)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item[dataKey.key]) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { class: { "grey--text text--darken-1": !_vm.hover } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.pluralize(
                                dataKey.displayName,
                                _vm.item[dataKey.key]
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.rollbackItem
              ? [
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    { staticClass: "card-bg-2 font-weight-medium py-0" },
                    [
                      _vm._v("\n        Referenced import details\n        "),
                      _c(
                        "TertiaryBtn",
                        {
                          attrs: {
                            to: {
                              name: "allimports",
                              query: { search: _vm.rollbackItem.executionId },
                            },
                            small: "",
                            icon: "find_in_page",
                          },
                        },
                        [_vm._v("Go to import")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.rollbackItem
                    ? _c("DefaultRun", {
                        attrs: { hover: _vm.hover, item: _vm.rollbackItem },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _c("v-card-text", [
            _vm._v(
              "\n    The rollback process failed. View the logs for details.\n  "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }